export const getBuildingInputs = () => {
    return [
        {
            _key: "building_name",
            _name: "Building Name",
            _value: "",
            _type: "text",
            _placeholder: "Building Name",
            _helperText: "Please enter building name",
            _mandatory: true,
            _errorMsg: "",
            _gridSize: 6
        },
        {
            _key: "building_address",
            _name: "Building Address",
            _value: "",
            _type: "text",
            _placeholder: "Building Address",
            _helperText: "Please enter Building Address",
            _mandatory: true,
            _errorMsg: "",
            _options: {},
            _gridSize: 12
        },
    ];
}